<ndt-extension-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [showExtensionRegisterPopup]="showExtensionRegisterPopup$ | async"
   [accountId]="accountId | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [extensionPrivileges]="extensionPrivileges$ | async"
   [phonePrivileges]="phonePrivileges$ | async"
   [name]="entityName"
   [columns]="columns"
   [createExtensionTypeOptions]="createExtensionTypeOptions$ | async"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (createExtensionTypeChange)="onCreateExtensionTypeSelected($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   [isSystemUser]="isSystemUser$ | async"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-extension-register-view>
